import React, { useState, useEffect } from 'react';
import { Radio, Typography, Form } from 'antd';
// import { ButtonCommon } from '../Button/ButtonCommon';
import HeaderContent from '../HeaderContent/HeaderContent';
// import LabelWithRequired from '../Label/LabelWithRequired';
// import SelectCommon from '../Select/SelectCommon';
// import { Upload } from '@phosphor-icons/react';
import { Supplier } from 'models';
// import { supplierRules } from 'utils/formRules';
import ModalCommon from './ModalCommon';

const { Text, Link } = Typography;

interface ModalSupplierProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (supplierId: string) => void;
  saveButtonLabel?: string;
  headerLabel?: string;
  headerContent?: string;
  suppliers?: Supplier[];
}

const ModalSupplier: React.FC<ModalSupplierProps> = ({
  open,
  onClose,
  onConfirm,
  saveButtonLabel,
  headerLabel,
  headerContent,
  suppliers,
}) => {
  const [form] = Form.useForm();
  const [selectedValue, setSelectedValue] = useState('current');
  const [selectedSupplier, setSelectedSupplier] = useState<Supplier | undefined>();
  useEffect(() => {
    if (suppliers && suppliers.length < 0) {
      setSelectedSupplier(suppliers[0]);
    }
  }, [suppliers, form]);
  const header = (
    <HeaderContent
      size='sm'
      key='confirm-create-product'
      label={headerLabel || `CHỌN NHÀ CUNG CẤP BẠN MUỐN TẠO ĐƠN`}
      contentHeader={headerContent || 'Vui lòng chọn nhà cung cấp'}
    />
  );
  return (
    <ModalCommon
      open={open}
      onClose={onClose}
      onConfirm={() => onConfirm(selectedSupplier?.id || '')}
      // confirmDisabled={!selectedSupplier}
      confirmLabel={saveButtonLabel || 'Xác nhận'}
      header={header}
    >
      <div className='px-6 py-3  pt-6 '>
        <div className=' text-sm'>
          <Text className='text-[var(--textBlack56)]'>
            Nhà cung cấp <span className='text-black'>{selectedSupplier?.baseUser?.name || ''}</span> vừa được cập nhật
            bảng giá bán vào ngày
            <span className='text-black'> 30/4/2025</span>
          </Text>
          <br />
          <Text className='text-[var(--textBlack56)]'>
            Tệp tin Excel giá mới nhất từ nhà cung cấp:{' '}
            <Link href='/BANGGIA304.xls' target='_blank' className='text-[var(--primaryColor500)] font-bold'>
              BANGGIA304.xls
            </Link>
          </Text>
        </div>
        {/* <div className='px-6 py-3'>
          <Form form={form} layout='vertical'>
            <Form.Item
              label={<LabelWithRequired label='Nhà cung cấp' />}
              rules={supplierRules}
              required={false}
              name='supplierId'
              className='mb-0'
            >
              <SelectCommon
                placeholderSelect='Chọn nhà cung cấp'
                className='bg-white'
                defaultValue={selectedSupplier?.id}
                options={
                  suppliers?.map((supplier) => ({
                    label: supplier.baseUser.name || '',
                    value: supplier.id || '',
                  })) || []
                }
                selectType='filterSelect'
                onChange={(value) => {
                  const found = suppliers?.find((s) => s.id === value);
                  setSelectedSupplier(found);
                }}
              />
            </Form.Item>
          </Form>
        </div> */}
        <Radio.Group
          buttonStyle='solid'
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
          className='w-full flex flex-col gap-6 mt-6 px-6 pt-3'
        >
          {/* <div
            className={`bg-white px-6 py-3 rounded-2xl border ${
              selectedValue === 'content' ? 'border-[var(--primaryColor500)]' : 'border-transparent'
            }`}
          >
            <div className='flex justify-between'>
              <div>
                <p>
                  <Radio value='content' className='text-black font-bold custom-radio'>
                    Thông tin liên hệ nhà cung cấp
                  </Radio>
                </p>
                <p className='pl-6 mt-3'>
                  <Text className=' text-[var(--textBlack56)]'>1. Số điện thoại liên hệ</Text>
                  <Link
                    className='text-[var(--primaryColor500)] font-bold'
                    href={`tel:${selectedSupplier?.baseUser?.phoneNumber || selectedSupplier?.baseUser?.phoneNumber}`}
                  >
                    {' '}
                    {selectedSupplier?.baseUser?.phoneNumber || ''}
                  </Link>
                </p>
                <p className='pl-6 mt-3'>
                  <Text className=' text-[var(--textBlack56)]'>2. Liên hệ theo địa chỉ</Text>
                  <Link
                    className='text-[var(--primaryColor500)] font-bold'
                    href={`mailto:${selectedSupplier?.baseUser?.email || ''}`}
                  >
                    {' '}
                    {selectedSupplier?.baseUser?.email || ''}
                  </Link>
                </p>
                <p className='pl-6 mt-3'>
                  <Text className=' text-[var(--textBlack56)]'>3. Quét QR để liên hệ với nhà cung cấp qua Zalo</Text>
                </p>
              </div>
              <div>
                {selectedSupplier && (
                  <QRCode
                    size={117}
                    className='p-1'
                    value={`https://zalo.me/${selectedSupplier?.baseUser?.phoneNumber || ''}`}
                  />
                )}
              </div>
            </div>
            <ButtonCommon
              color='basic'
              radius='rounded'
              size='sm'
              className='bg-[var(--bgBlackOpacity)] text-black gap-2 mt-3 ml-6'
              icon={<Upload size={20} />}
              iconPosition='left'
            >
              <span className='whitespace-nowrap'> Tải lên tệp Excel giá sản phẩm mới nhất</span>
            </ButtonCommon>
          </div> */}

          <div
            className={`bg-white px-6 py-3 rounded-2xl ${
              selectedValue === 'current' ? 'border border-[var(--primaryColor500)]' : ''
            }`}
          >
            <div>
              <Radio value='current' className='custom-radio'>
                Giá sản phẩm đang là mới nhất
              </Radio>
            </div>
            <p className='pl-6 mt-1'>
              <Text className=' text-[var(--textBlack56)]'>
                Bạn đã cập nhật giá mới nhất của các sản phẩm trên hệ thống
              </Text>
            </p>
          </div>
        </Radio.Group>
      </div>
    </ModalCommon>
  );
};

export default ModalSupplier;
